<template>
  <v-layout column>
    <v-layout v-bind:style="{'height' : height + 'px'}" style="width: 100%; border: 1px solid lightgrey; border-radius: 5px; background-color: lightgrey" class="mt-2">
      <div v-for="(item, index) of items" :key="index"
           v-bind:style=
             "{'width': `${Math.ceil((item[value] ? item[value] : 0 )/ total * 100)}%`,
                'background-color': colorRender(index),
                'border-top-left-radius' : index === 0 ? '5px' : '',
                'border-bottom-left-radius'  : index === 0 ? '5px' : ''
             }"
           style="height: 100%;"
      ></div>
    </v-layout>
    <v-layout class="flex-wrap" v-if="legend">
      <div class="d-flex ml-3" v-for="(item, index) of items" :key="'name:' + index"><v-icon :color="colorRender(index)">mdi-circle-medium</v-icon>{{item[text] ? item[text] : ''}}</div>
      <div class="ml-3 d-flex"><v-icon color="lightgrey">mdi-circle-medium</v-icon>Free</div>
    </v-layout>
  </v-layout>
</template>

<script>
import { rybColorWheel, randomColorRGB } from '@/utils/Color'
export default {
  name: 'percent-line',
  props: {
    items: {
      type: Array,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    total: {
      type: Number,
      required: false
    },
    legend: {
      type: Boolean,
      required: false
    },
    height: {
      type: Number,
      required: false
    }
  },
  methods: {
    colorRender (index) {
      return rybColorWheel[index + 1] || randomColorRGB()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/percent-line.vue